import React from 'react';
import { Mail } from 'lucide-react';
import ContactForm from '../components/ContactForm';

const ContactHero = () => (
  <section className="relative py-20 overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-br from-[#0a1628] via-[#0f1d32] to-[#162544]" />
    <div className="absolute bottom-1/3 right-1/4 w-96 h-96 bg-[#3b82f6]/10 rounded-full blur-3xl" />
    
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-xl bg-[#3b82f6]/20 flex items-center justify-center">
            <Mail className="w-6 h-6 text-[#3b82f6]" />
          </div>
          <span className="text-[#3b82f6] font-medium">Get in Touch</span>
        </div>
        <h1 className="text-4xl sm:text-5xl font-bold text-[#f1f5f9] mb-6 animate-fade-in-up">
          Let's Build Together
        </h1>
        <p className="text-xl text-[#94a3b8] leading-relaxed animate-fade-in-up delay-100">
          Whether you need field services, educational seminars, or strategic advisory, 
          we're here to help bring your telecommunications projects to life.
        </p>
      </div>
    </div>
  </section>
);

const Contact = () => {
  return (
    <div className="min-h-screen bg-[#0a1628]">
      <ContactHero />
      <section className="py-20 bg-[#0f1d32]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <ContactForm />
        </div>
      </section>
    </div>
  );
};

export default Contact;
